import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import VueLazyload from 'vue-lazyload'
import VCalendar from 'v-calendar'

// Global css
import '@/css/bootstrap-override.scss'
import '@/css/styles.css'
import '@/css/skeleton.css'
import '@/css/modal.css'
import '@/css/inputs.css'
import 'v-calendar/style.css'

import initI18n from './translations'

// Init
import setEnvFile from './init/setEnvFile'
import { setLocalDevCookies } from './init/setLocalDevCookies'
import Cookies from 'js-cookie'

// Config
import { CookieName } from './config/cookies'

// Services
import CSEService from './services/CSEService'

// Composables
import { useHeaderFooter } from '@/composables/useHeaderFooter'

// Utils
import { normalizeLocale } from './utils'

// Types
import { Locale } from './types'

const { injectHeaderAndFooter } = useHeaderFooter()
const cseService = new CSEService()

async function startApp() {
  try {
    setLocalDevCookies()
    await setEnvFile()

    // Origin-based auto-login handling is intentionally disabled for now.
    // Keep origin in URL for analytics only; auth continues through standard flow.
    // await store.dispatch('auth/handleBookingUILogin')
    // await store.dispatch('auth/handleCustomerUILogin')

    // Wait for companyLang to be set
    await cseService.setCompanyLang()

    window.locale = store.getters.getLocale //Set locale for login components
    document.documentElement.setAttribute('lang', normalizeLocale(window.locale as Locale))

    const app = createApp(App)
    app.use(router)
    app.use(store)
    app.use(VueLazyload)

    app.use(VCalendar, {})

    initI18n(app, store.getters.getLocale)

    app.mount('#app')
  } catch (err) {
    console.error('Error starting the app:', err)
  }

  injectHeaderAndFooter(
    window.env.VUE_APP_MENU_DOMAIN,
    store.getters.getLocale,
    Cookies.get(CookieName.COMPANY)
  )
}

startApp()
